import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useDeliveryContext } from "../../context/delivery.context";
import { DeliveryItemContextProvider } from "./deliveryItem/context/deliveryItem.context";

const DeliveryTypesBase = ({ children }: RequireChildrenFor<{}>) => {
    const {
        options,
        roundingValue,
        xfPath,
        preferredStore,
        minimumOrderQuantity,
        activeDelivery,
        activeServiceProducts,
        changeDelivery,
        changeServiceProduct,
        deliveryTypesDisabled,
        infoLink,
        isBoxArticle,
        isLimitedStock,
        montageParents,
        montages,
        sku,
        boxLogisticInformation,
        tooltips
    } = useDeliveryContext();

    return (
        <div
            className={cn(
                "tw:w-full tw:bg-background tw:border tw:border-grey-input tw:rounded-sm"
            )}
            data-test={"deliveryBlock"}
        >
            {options.map((option) => {
                return (
                    <DeliveryItemContextProvider
                        key={option.deliveryType}
                        option={option}
                        preferredStore={preferredStore}
                        activeDelivery={activeDelivery}
                        activeServiceProducts={activeServiceProducts}
                        changeDelivery={changeDelivery}
                        changeServiceProduct={changeServiceProduct}
                        deliveryTypesDisabled={deliveryTypesDisabled}
                        infoLink={infoLink}
                        isBoxArticle={isBoxArticle}
                        isLimitedStock={isLimitedStock}
                        montageParents={montageParents}
                        montages={montages}
                        sku={sku}
                        boxLogisticInformation={boxLogisticInformation}
                        tooltips={tooltips}
                        roundingValue={roundingValue}
                        xfPath={xfPath}
                        minimumOrderQuantity={minimumOrderQuantity}
                    >
                        {children}
                    </DeliveryItemContextProvider>
                );
            })}
        </div>
    );
};

export { DeliveryTypesBase };
